//for press Video Page
$(document).ready(function(){
  $('.pressYouTubeContainer iframe[src*="youtube"], video').each(function(){
    $(this).data('video-ratio', $(this).height()/$(this).width());
  });
  
  function ptWindowWidthResizer() {
    var width = $('.pressYouTubeContainer').width();
    $('.pressYouTubeContainer iframe[src*="youtube"]').each(function(){
      var ratio = $(this).data('video-ratio');
     	$(this).css({
        width: width + 'px',
        height: width*ratio + 'px'
      });
    });
    
    $('video').each(function(){
      var ratio = $(this).data('video-ratio');
     	$(this).css({
        'width': width + 'px',
        'height': width*ratio + 'px',
        //'max-width': '360px',
        //'max-height': 360*ratio + 'px'
      });
    });
  }
  window.addEventListener('resize', ptWindowWidthResizer);
  ptWindowWidthResizer();
});